export default __webpack_public_path__ + "static/media/yaroslavl_sellers.a658f929.jpg";